// extracted by mini-css-extract-plugin
export default {"fieldHeader":"SettingsPanelHeader_fieldHeader__xTrGk","valueHeader":"SettingsPanelHeader_valueHeader__+3Gnb"};